import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from './Checkbox';

const Checklist = ({
  columns,
  disabled,
  label,
  onChange,
  options,
  selected,
  showSelectAll,
  style
}) => {
  const styles = {
    options: {
      columnCount: columns
    },
    option: {
      padding: '4px 0',
      cursor: 'pointer'
    }
  };
  const values = options.map(o => o.value);

  const handleChange = value => {
    const new_selected = [...selected];

    if (selected.includes(value)) {
      new_selected.splice(new_selected.indexOf(value), 1);
    } else {
      new_selected.push(value);
    }

    onChange(new_selected);
  };

  const onToggleAll = () => {
    if (selected.length === values.length) {
      onChange([]);
    } else {
      onChange(values);
    }
  };

  return (
    <div style={style}>
      {label ? (
        <>
          <div>{label}</div>
          <br />
        </>
      ) : null}

      {showSelectAll && values.length ? (
        <div style={styles.option}>
          <Checkbox
            checked={selected.length === values.length}
            disabled={disabled}
            label='Select All'
            onChange={onToggleAll}
          />
        </div>
      ) : null}

      <div style={styles.options}>
        {options.map((o, i) => {
          const is_selected = selected.includes(o.value);
          const label = o.label || o.value;

          return (
            <div key={i} style={styles.option}>
              <Checkbox
                checked={is_selected}
                disabled={disabled}
                label={label}
                onChange={handleChange.bind(null, o.value)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

Checklist.propTypes = {
  columns: PropTypes.number,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ).isRequired,
  selected: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  showSelectAll: PropTypes.bool
};

export default Checklist;
